export const isValidSSN = (value: string): boolean => {
  if (!value) return false;
  const cleaned = value.replace(/[-\s]/g, '');
  const validSsnRegex = /^\d{9}$/;
  return cleaned.length === 9 && validSsnRegex.test(cleaned);
};
